import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ReactDOM from "react-dom";
import Editor from "../../Editor";

const LessonDataCarta = ({ data = undefined, onChange = () => {} }) => {
  const [text, setText] = useState("");

  useEffect(() => {
    onChange({ description: text, type: "LESSON_CARTA" });
  }, [text, onChange]);

  useEffect(() => {
    if (!data) return;

    setText(data?.description);
  }, [data]);

  return (
    <Container>
      <BoxType src="LESSON_CARTA.jpg" />

      <Editor
        theme="snow"
        value={text}
        onChange={setText}
        placeholder="Instrucciones"
        minHeight={200}
      />
    </Container>
  );
};

const Container = styled.div``;

const BoxType = styled.img`
  width: 180px;
  height: 180px;
  object-fit: cover;
  background-color: black;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px;
`;

export default LessonDataCarta;
